import classes from './deleteEmail.scss';
import classess from '../../../Centralized/CPCGuest/GuestBPSearch/guestBPSearch.scss';
import { getLocalizedStrings } from '../../profileSettingsLocalizedStrings';
const DeleteEmail = (props) => {
  let strings = getLocalizedStrings('NotificationSettings');
   let warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
 return(
    <div>
      <div className={classes.deleteDataRow}>
     <span className={classes.emailData}>{props.phoneNo}</span>
        <span className={classes.mobileButtonAlign}>
          <div className={classes.buttonAlign}>
            <span className={classes.removeButtonAlign}>
            <button className={classes.RemoveButton} onClick={(e,sn) =>props.deleteButtonHandler(e,props.voice)} disabled={props.voiceData.lastEAPreference}>{strings.deleteButtonValue}</button>
          </span>
          <span className={classes.EditButtonAlign}>
            <button className={classes.CancelButton} onClick={props.removeCancelHandler}>{strings.CancelButtonValue}</button>
          </span>
        </div>
        <div>
        {props.voiceData.voiceErr ?
          <div className={classes.errorBox}> 
            <span><img className={classes.warningImg} src={warningIcon} alt="Warning Icon" /></span>
            <span className={classes.emailError}>
              {props.voiceData.lastEAPreference ? <span>{strings.deleteErrMsg4}</span> : <span>{strings.deleteErrMsg}&nbsp;
              {props.voiceData.preferenceError.join(', ')}{strings.deleteErrMsg2}
              {props.voiceData.preferenceError.join(', ')}{strings.deleteErrMsg3}</span>}
            </span>
          </div> : null           
        }
        {props.voiceData.modifyVoiceError ? <span className={classess.searchError + ' ' + classes.phoneError + ' ' + classes.errorBox}>{strings.errorMsg}</span> : null}
      </div>
       
      </span>
        </div>
    </div>
  );
};
export default DeleteEmail;
